<!-- 车位周转数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "startDate": "20190910000000",
                "endDate": "20190910235959",
            },
            responseCode: {

                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 车场交易数据-版本2",
                t_url: this.commonUrls.test+"dealForParkVer2",
                p_url: this.commonUrls.prod+"dealForParkVer2",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '统计日期范围 0昨天, 1当月, 2当年' },
                        { info1: 'parkCodeList', info2: '是', info3: 'List', info4: '车场编码列表' },
                        { info1: 'number', info2: '是', info3: 'Long', info4: '条数' },
                        ]
                }],
                R_params: [{

                  titleName: "recordList",
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'recordList', info2: '是', info3: 'List', info4: '数据' },
                  ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '车场名' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '车场编码' },
                        { info1: 'tradeValue', info2: '否', info3: 'BigDecimal', info4: '交易金额' },
                        { info1: 'tradeValueStr', info2: '否', info3: 'String', info4: '交易金额（以万形式显示）' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/dealForParkVer2.vue